import classNames from 'classnames';
import { useEffect, useRef, useState } from 'react';
import * as React from 'react';
import './styles/Image.scss';

interface ImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {}

type ImageLoadingState = 'loading' | 'loaded' | 'error';

function Image({
    className = '',
    sizes = '',
    alt = '',
    loading,
    onLoad,
    onError,
    ...props
}: ImageProps) {
    const imageRef = useRef<HTMLImageElement>(null);
    const [imageLoading, setImageLoading] = useState<ImageLoadingState>('loading');
    const blockClass = 'palette-image';
    const classes = classNames(blockClass, `${blockClass}--${imageLoading}`, {
        [`${blockClass}--lazy`]: loading === 'lazy',
    }, className);

    const handleImageLoad: React.ReactEventHandler<HTMLImageElement> = (event) => {
        onLoad?.(event);
        setImageLoading('loaded');
    };

    const handleImageError: React.ReactEventHandler<HTMLImageElement> = (event) => {
        onError?.(event);
        setImageLoading('error');
    };

    useEffect(() => {
        setImageLoading(imageRef.current?.complete ? 'loaded' : 'loading');
    }, [props]);

    return (
        <img
            ref={imageRef}
            alt={alt}
            className={classes}
            loading={loading}
            sizes={sizes}
            onError={handleImageError}
            onLoad={handleImageLoad}
            {...props}
        />
    );
}

export default Image;
